import React, { useEffect, useState } from 'react';
import EventList from './EventList';
import { Event } from './types';
import axios from 'axios';
import { instance } from '../../api/axiosInstance';
import Loading from "../../components/Loading";

const EventPage: React.FC = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [eventsPerPage] = useState(9);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // 페이지네이션 계산
  const indexOfLastEvent = currentPage * eventsPerPage;
  const indexOfFirstEvent = indexOfLastEvent - eventsPerPage;
  const currentEvents = events.slice(indexOfFirstEvent, indexOfLastEvent);
  const totalPages = Math.ceil(events.length / eventsPerPage);

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await instance.get<Event[]>('/api/events'); // API 엔드포인트 확인
        setEvents(response.data);
      } catch (err) {
        if (axios.isAxiosError(err)) {
          setError(err.response?.data?.message || '이벤트를 불러오는 중 오류가 발생했습니다.');
        } else {
          setError('이벤트를 불러오는 중 예상치 못한 오류가 발생했습니다.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  return (
    <section className="flex flex-col justify-between max-w-[2560px] w-full mx-auto  h-screen pb-[100px] mobile:px-4">
      <div className="mt-[130px] mobile:mt-[130px] max-w-[1440px] w-full mx-auto">
        <h2 className="flex items-center text-3xl Pretendard-Bold mobile:text-lg text-[#000]">
          이벤트
        </h2>
        <p className="mb-[20px] Pretendard-Regular text-sm mobile:text-xs tracking-wide text-[#414042] leading-6">
          이벤트를 확인합니다.
        </p>

        {loading && (
          <div className="flex justify-center items-center">
            <Loading />
          </div>
        )}
        {error && <p className="text-red-500">{error}</p>}
        {!loading && !error && events.length === 0 && (
          <p className="text-center text-gray-500">진행중인 이벤트가 없습니다.</p>
        )}
        {!loading && !error && events.length > 0 && <EventList events={currentEvents} />}
      </div>

      {/* 네비게이터를 하단에 고정 */}
      {events.length > 0 && (
        <div className="flex justify-center mt-auto mb-[20px]">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              onClick={() => paginate(index + 1)}
              className={`px-4 py-2 mx-1 rounded-lg ${
                currentPage === index + 1
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-300'
              }`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
    </section>
  );
};

export default EventPage;
